import { render, staticRenderFns } from "./CreditBalancePill.vue?vue&type=template&id=1b5e03ee&scoped=true"
import script from "./CreditBalancePill.vue?vue&type=script&lang=js"
export * from "./CreditBalancePill.vue?vue&type=script&lang=js"
import style0 from "./CreditBalancePill.vue?vue&type=style&index=0&id=1b5e03ee&prod&scoped=true&lang=css"
import style1 from "./CreditBalancePill.vue?vue&type=style&index=1&id=1b5e03ee&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5e03ee",
  null
  
)

export default component.exports